export default class Config {
    public static readonly ApiServerAddress: string = "https://mietpumpen.ch/api/v2";
    public static readonly DeviceApiServerAddress: string = Config.ApiServerAddress + "/devices";
}